// Minimal first-touch paid-ad attribution.
// Captures UTM + click-id params on landing and persists them so they survive
// landing -> lead -> checkout -> purchase.
const KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid", "gclid"];
const STORE = "ely_attrib";

export function captureAttribution() {
  try {
    const p = new URLSearchParams(window.location.search);
    const found = {};
    KEYS.forEach((k) => {
      const v = (p.get(k) || "").trim();
      if (v) found[k] = v.slice(0, 300);
    });
    if (Object.keys(found).length === 0) return getAttribution();
    // First-touch: only write once, so the original campaign is preserved.
    if (!localStorage.getItem(STORE)) {
      localStorage.setItem(STORE, JSON.stringify(found));
    }
  } catch {}
  return getAttribution();
}

export function getAttribution() {
  try {
    return JSON.parse(localStorage.getItem(STORE) || "{}");
  } catch {
    return {};
  }
}
